export function SignReady2Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.5123 6.42671C11.748 6.14386 11.7098 5.72348 11.427 5.48777C11.1441 5.25206 10.7237 5.29028 10.488 5.57313L7.55081 9.09778L5.72099 7.79077C5.42138 7.57676 5.00501 7.64616 4.79101 7.94576C4.577 8.24537 4.6464 8.66174 4.946 8.87575L7.78285 10.9021L11.5123 6.42671Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00016 1.33325C4.31826 1.33325 1.3335 4.31802 1.3335 7.99992C1.3335 11.6818 4.31826 14.6666 8.00016 14.6666C11.6821 14.6666 14.6668 11.6818 14.6668 7.99992C14.6668 4.31802 11.6821 1.33325 8.00016 1.33325ZM2.66683 7.99992C2.66683 5.0544 5.05464 2.66659 8.00016 2.66659C10.9457 2.66659 13.3335 5.0544 13.3335 7.99992C13.3335 10.9454 10.9457 13.3333 8.00016 13.3333C5.05464 13.3333 2.66683 10.9454 2.66683 7.99992Z"
        fill="currentColor"
      />
    </svg>
  );
}
